const UTM_STORAGE_KEY = 'opspilot_signup_utm';

const UTM_FIELDS = [
	['utmSource', 'utm_source'],
	['utmMedium', 'utm_medium'],
	['utmCampaign', 'utm_campaign'],
	['utmContent', 'utm_content'],
	['utmTerm', 'utm_term'],
];

function readFromParams(search) {
	const params = new URLSearchParams(search);
	const attribution = {};

	for (const [key, param] of UTM_FIELDS) {
		const value = params.get(param)?.trim();
		if (value) attribution[key] = value;
	}

	return Object.keys(attribution).length ? attribution : null;
}

function readStored() {
	try {
		const raw = sessionStorage.getItem(UTM_STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		return parsed && typeof parsed === 'object' ? parsed : null;
	} catch {
		return null;
	}
}

export const captureUtmFromSearch = (search) => {
	const fromUrl = readFromParams(search);
	if (!fromUrl) return null;

	const merged = { ...readStored(), ...fromUrl, capturedAt: new Date().toISOString() };
	sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(merged));
	return merged;
};

export const getSignupAttribution = (search = '') => {
	const fromUrl = readFromParams(search);
	const stored = readStored();
	if (fromUrl || stored) {
		return { ...stored, ...fromUrl };
	}
	return null;
};

export const clearSignupAttribution = () => {
	sessionStorage.removeItem(UTM_STORAGE_KEY);
};

export const isAppSumoAttribution = (attribution) =>
	attribution?.utmSource?.toLowerCase() === 'appsumo';
